import React, { useState, useEffect } from 'react';
import vr from '../../../../utils/Verifiers';
import CloseButton from '../../../sharecomponents/CloseButton';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import { backendApi } from '../../../../utils/APIs';
import AutoCompleteInput from '../../../sharecomponents/AutocompleteImput';

const AsociadorUsuariosExternosNomina = (p) => {
    const [loader, setloader] = useState(false);
    const [dialog, setdialog] = useState({ show: false });

    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader-local' /></div>);
    const closeFunction = p.close;
    const [usuariosNomina, setusuariosNomina] = useState({});
    const [usuariosNombres, setusuariosNombres] = useState([]);
    const [seleccionUsuario, setseleccionUsuario] = useState(false);
    const [usuarioLocal, setusuarioLocal] = useState();
    useEffect(() => {
        getEmpleadosNomina();
        setseleccionUsuario(false);
        setusuarioLocal(p.usuario ?? {});
    }, []);

    const getEmpleadosNomina = async () => {

        let respDatos = await vr.getDataAPI("/nomina/oto/encargados/nomina/externa", {}, setloader, setdialog);
        if (!respDatos) {
            return;
        };
        respDatos = respDatos.data;
        const hashUsuariosNomina = {};
        const nombres = [];
        respDatos.forEach(user => {
            const nombre = `${(user?.nombre ?? "").trim()} | ${(user?.perfil ?? "").trim()} | ${user.id}`;
            nombres.push(nombre);
            hashUsuariosNomina[nombre] = user;
        });
        setusuariosNomina({ ...hashUsuariosNomina });
        setusuariosNombres([...nombres]);
    }

    const vincularEmpleado = async () => {
        if (!seleccionUsuario) return;
        const payload = {
            nombre: seleccionUsuario?.nombre,
            correo: seleccionUsuario?.correo,
            id_externo: seleccionUsuario?.id,
            posicion: seleccionUsuario?.posicion,
            perfil: seleccionUsuario?.perfil,
            user_id: usuarioLocal?.id
        }
        const resp = await vr.getDataAPI("secure/users/vincular/add", payload, setloader, setdialog);
        if (!resp) return;
        closeFunction(true);
    }

    const desvincular = async (id_usr) => {
        const resp = await vr.getDataAPI(`secure/users/vincular/${id_usr}/delete`, {}, setloader, setdialog);
        if (!resp) return;
        closeFunction(true);
    }

    return (
        <>
            <div className='w-100 h-100 blur-m text-center p-0 m-0 ' style={{ zIndex: 999, position: 'absolute', top: 0, left: 0, overflow: 'auto' }}>
                <div className='row justify-content-center w-100 m-0 p-0'>
                    <CloseButton close={() => closeFunction(false)} />
                    <div className='bw-600 round-xs shadow-sm border bg-white p-2 pt-5 pb-5'>
                        <div className='col-lg-12 fw-light h4 text-center'>
                            {usuarioLocal?.nombre}
                            <span className={`text-s ms-2 ${usuarioLocal?.vinculacion ? "text-green3" : "text-muted"} fw-bold`}>{usuarioLocal?.vinculacion ? "Vinculado" : "Sin vincular"}</span>
                        </div>

                        <div className='row justify-content-evenly w-100 m-0 p-0'>
                            {usuarioLocal?.vinculacion && <>
                                <div className='col-lg-12 m-0 p-0 mt-3'></div>
                                <div className='bw-500 round-xs border bg-white p-2 border'>
                                    <div className='col-lg-12 h5 text-300'>Vinculo en aplicacion nómina</div>
                                    <div className='col-lg-12 text-bold text-s'>{usuarioLocal?.vinculacion?.nombre}</div>
                                    <div className='col-lg-12 text-300 text-s'>{usuarioLocal?.vinculacion?.correo}</div>
                                    <div className='col-lg-12 text-300 text-s'>{usuarioLocal?.vinculacion?.posicion}</div>
                                </div>
                                <div className='col-lg-12 m-0 p-0 mt-3 mb-5'>
                                    <button className='btn btn-danger shadow bw-400 btn-sm round-xs text-bold' onClick={() => desvincular(usuarioLocal?.id)}>Desvincular</button>
                                </div>
                            </>}
                            <div className='col-lg-12 text-center'>Seleccione un usuario de nómina para crear o actualizar la vinculación del usuario</div>
                            <AutoCompleteInput
                                style="bw-500 relative m-0 mb-2 p-0"
                                label='SELECCIONE UN USUARIO'
                                inputClass={' round-xs form-control-sm border border-2 shadow-sm text-center contenedor ' + (!seleccionUsuario ? '' : 'border border-success border-2')}
                                text_class="text-bold ps-2 w-100 text-s text-start"
                                id="laborador-input"
                                disabled={usuariosNombres.length === 0}
                                match={usuariosNombres}
                                function={(selectUser) => {
                                    if (usuariosNomina[selectUser]) setseleccionUsuario({ ...usuariosNomina[selectUser] })
                                    else setseleccionUsuario(false);
                                }}
                            />
                            {seleccionUsuario && <>
                                <div className='col-lg-12 m-0 p-0 mt-3'></div>
                                <div className='bw-500 round-xs shadow border bg-white p-2 border border-2 border-success'>
                                    <div className='col-lg-12 h3 text-300'>Usuario a vincular</div>
                                    <div className='col-lg-12 text-bold text-m'>{seleccionUsuario?.nombre}</div>
                                    <div className='col-lg-12 text-300 text-m'>{seleccionUsuario?.correo}</div>
                                </div>
                                <div className='col-lg-12 m-0 p-0 mt-3'>
                                    <button className='btn btn-warning shadow bw-400 btn-lg round-xs text-bold' onClick={vincularEmpleado}>Vincular al empleado seleccionado</button>
                                </div>
                            </>}
                        </div>
                    </div>


                </div>
                {loader && ldr}
            </div>
            <VainillaDialog data={dialog} />
        </>
    )
}

export default AsociadorUsuariosExternosNomina;